<div class="cod-modal">

  <div class="cod-header">
    <h2 class="cod-header__title">Commercial Owners</h2>
    <button type="button" class="cod-header__close" (click)="close()" aria-label="Close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="cod-divider"></div>

  <ul class="cod-owners">
    <li class="cod-owners__item" *ngFor="let owner of data.owners">{{ owner }}</li>
  </ul>

</div>
